import React, {ReactNode} from 'react'
import {Box, IconButton, Stack, Tooltip} from "@mui/material"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import {TOP_NAV_HEIGHT, RIGHT_SIDEBAR_WIDTH, RIGHT_SIDEBAR_WIDTH_COLLAPSED} from "./layoutConstants"
import {useRightSidebarCollapsed} from "../../hooks/useCollapsible"

interface RightSidebarProps {
    children: ReactNode
}

function RightSidebar({children}: RightSidebarProps) {
    const [collapsed, toggleCollapsed] = useRightSidebarCollapsed()

    const width = collapsed ? RIGHT_SIDEBAR_WIDTH_COLLAPSED : RIGHT_SIDEBAR_WIDTH

    return (
        <Stack
            sx={{
                position: 'fixed',
                top: `${TOP_NAV_HEIGHT}px`,
                right: 0,
                width,
                height: `calc(100vh - ${TOP_NAV_HEIGHT}px)`,
                bgcolor: '#f9f9fb',
                borderLeft: '1px solid #ececf1',
                zIndex: 999,
                overflowY: collapsed ? 'hidden' : 'auto',
                overflowX: 'hidden',
                boxSizing: 'border-box',
                transition: 'width 200ms ease',
                justifyContent: 'space-between',
            }}
        >
            {collapsed ? (
                <Box sx={{flex: 1}}/>
            ) : (
                <Box sx={{p: '32px 24px'}}>
                    {children}
                </Box>
            )}

            <Tooltip title={collapsed ? "Show activity" : "Hide activity"} placement="left">
                <IconButton
                    onClick={toggleCollapsed}
                    size="small"
                    sx={{
                        color: '#999',
                        alignSelf: 'flex-end',
                        mt: 3,
                        mb: 4,
                        mr: collapsed ? 'auto' : 2,
                        ml: collapsed ? 'auto' : 0,
                        '&:hover': {color: '#555'},
                    }}
                >
                    {collapsed ? <ChevronLeftIcon fontSize="small"/> : <ChevronRightIcon fontSize="small"/>}
                </IconButton>
            </Tooltip>
        </Stack>
    )
}

export default RightSidebar
